module.exports = __webpack_public_path__ + "static/media/img-patrocinio.29c5b3c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/img-patrocinio.jpg
// module id = 136
// module chunks = 8